/** Store features in the back office (D101). Pure: no I/O. */

// Words for the open-work counts setFeatures reports (lib/store/features inFlight).
const COUNT_LABELS = { open_tickets: 'open repair tickets', unpaid_invoices: 'unpaid repair invoices' };

/** What switching repairs off does to the open work the confirm dialog lists (user decision 2026-11-02, security re-review N2). */
export const SWITCH_OFF_CONSEQUENCE =
  'Switching off stops new bookings and staff work. Customers can still track these, approve estimates, schedule the return and pay, but your staff cannot move them on until you switch it back on. Parts reserved for approved estimates stay reserved, and staff cannot release them until then.';

/**
 * The open work a 409 FEATURE_IN_USE lists (body.data.in_flight: { <feature>: { <count name>: n } }),
 * as [{ name, count, label }]; null for any other error. Exported for tests.
 */
export function inFlightOf(ex) {
  const body = ex && ex.response && ex.response.data;
  const inFlight = body && body.code === 'FEATURE_IN_USE' && body.data && body.data.in_flight;
  if (!inFlight || typeof inFlight !== 'object') return null;
  return Object.values(inFlight).flatMap((counts) =>
    Object.entries(counts || {}).map(([name, n]) => ({ name, count: Number(n) || 0, label: COUNT_LABELS[name] || name.replace(/_/g, ' ') })),
  );
}
